export const formatPhoneNumber = (phoneNumberString: string) => {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3}|\d{2}|\d{1}|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] !== "1" ? (match[1] ? `+${match[1]} ` : "") : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return phoneNumberString;
};
